import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../contrib/ui';

export const StyledSetCTPWinner = styled.div`
  .title {
    display: flex;
    flex-direction: row;
    position: relative;
    justify-content: center;

    .button {
      color: var(--mainColor);
      position: absolute;
      top: 0;
      left: 0;
      width: ${px(100)};
      padding-top: 0;

      .label {
        ${fontFamilySize('Heavy')}
      }
    }
    h2 {
      width: ${px(150)} !important;
    }
  }

  .scorer {
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: ${px(20)};

    img {
      height: ${px(40)};
      width: ${px(40)};
      margin-right: ${px(10)};
      border-radius: ${px(40)};
    }
    .scorer-name {
      ${fontFamilySize('Bold', 16)}
    }
  }
  .paper {
    margin-bottom: ${px(20)};
    padding: ${px(20)};
    padding-top: 0;

    .inputs {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      .input-container {
        width: 45%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: flex-end;

        .material-input {
          ${fontFamilySize('Heavy', 30)}
          margin-right: ${px(5)};
          padding-bottom: ${px(8)};

        }

        label {
          ${fontFamilySize('Bold', 16)}
          padding-bottom: ${px(10)}
        }
      }
    }
  }
`;
